// extracted by mini-css-extract-plugin
export default {"errorCard":"Error_errorCard__cLbBB","errorContent":"Error_errorContent__C84Fs"};